import Alpine from 'alpinejs';
import './plugins/Craft';
import biddingButton from './components/BiddingButton';
import initJsStyles from './components/JsStyles';
import header from './components/Header';
import initHeroSlider from './components/HeroSlider';
import initInfiniteScroll from './components/InfiniteScroll';
import productGallery from './components/ProductGallery';
import smallGallery from './components/SmallGallery';
import accordion from './components/Accordion';
import modal from './components/Modal';
import videoModal from './components/VideoModal';
import addressModal from './components/AddressModal';
import deleteAccountModal from './components/DeleteAccountModal';
import fileUpload from './components/FileUpload';
import initCookieConsent from './components/CookieConsent';
import scrollToFaq from './components/ScrollToFaq';
import wishlistModal from './components/WishlistModal';
import directBuyModal from './components/DirectBuyModal';

window.header = header;
window.productGallery = productGallery;
window.smallGallery = smallGallery;
window.accordion = accordion;
window.videoModal = videoModal;
window.modal = modal;
window.deleteAccountModal = deleteAccountModal;
window.fileUpload = fileUpload;
window.addressModal = addressModal;
window.wishlistModal = wishlistModal;
window.directBuyModal = directBuyModal;
window.cookieConsent = initCookieConsent;

window.Alpine = Alpine;

document.addEventListener('alpine:init', () => {
  initJsStyles();
  biddingButton();
  scrollToFaq();
});

Alpine.start();

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    // eslint-disable-next-line no-console
    console.log('HMR');
  });
}

initHeroSlider();
initInfiniteScroll();
